module.exports = __webpack_public_path__ + "img/bluePlus.a560c5d6.svg";